export const SYSTEM_INPUT = 'SYSTEM_INPUT' as const;
export const SYSTEM_OUTPUT = 'SYSTEM_OUTPUT' as const;
